import {trackPromise} from 'react-promise-tracker';
import "babel-polyfill";


function buildMultiValueParams(data) {
    const params = new URLSearchParams()

    Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(value => params.append(key, value.toString()))
        } else {
            params.append(key, value.toString())
        }
    });
    return params
}

export const buildMultiValueUrl = (base, params) => `${base}?${buildMultiValueParams(params).toString()}`


export const buildUrl = (base, params) => {
    if (!params || Object.keys(params).length === 0) return base;
    const queryString = new URLSearchParams(params).toString();
    return queryString ? `${base}?${queryString}` : base;
}


export const getCsrfToken = () => {
    return document.querySelector('[name=csrfmiddlewaretoken]').value;
    //     // Extract CSRF token from cookies
//     var cookies = document.cookie.split(';');
//     var csrf_token = null;
//     $.each(cookies, function (index, cookie) {
//         var cookieParts = $.trim(cookie).split('=');
//         if (cookieParts[0] == 'csrftoken') {
//             csrf_token = cookieParts[1];
//         }
//     });
//     // Extract from cookies fails for HTML-Only cookies
//     if (!csrf_token) {
//         csrf_token = $(document.forms.valueOf()).find('[name="csrfmiddlewaretoken"]')[0].value;
//     }
//     return csrf_token;
};


export const patchDrfRequest = (url, data, data_callback = (data) => {
}, error_callback = (err) => {
}) => {
    trackPromise(fetch(url, {
        method: 'PATCH',
        headers: {
            'X-CSRFToken': getCsrfToken(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            if (!response.ok) throw response;
            return response.json();
        })
        .then(data_callback)
        .catch(error => {
            console.error("PATCH error:", error);
            error_callback(error);
        }));

}

// somehow delete works differently so we use async await and call the callback afterwards.
export const deleteDrfRequest = (url, data_callback = () => {
}, error_callback = (err) => {
}) => {
    trackPromise(fetch(url, {
        method: 'DELETE',
        headers: {
            'X-CSRFToken': getCsrfToken(),
            'Content-Type': 'application/json'
        },
    })
        .then(response => {
            if (!response.ok) throw response;
            return response;
        })
        .then(() => {
            data_callback();
        })
        .catch(error => {
            console.error("DELETE error:", error);
            error_callback(error);
        }));
}

export const postFormDataRequest = (url, formData = false, data_callback = (data) => {
}, error_callback = (err) => {
}) => {
    if (!formData) {
        return;
    }

    trackPromise(fetch(url, {
        method: 'POST',
        headers: {
            'X-CSRFToken': getCsrfToken(),
        },
        body: formData
    })
        .then(response => {
            if (!response.ok) throw response;
            return response.json();
        })
        .then(data_callback)
        .catch(error => {
            console.error("Upload error:", error);
            error_callback(error);
        }));
}


export const postDrfRequest = (url, data = {}, data_callback = (data) => {
}, error_callback = (err) => {
}) => {
    trackPromise(fetch(url, {
        method: 'POST',
        headers: {
            'X-CSRFToken': getCsrfToken(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            if (!response.ok) throw response;
            return response.json();
        })
        .then(data_callback)
        .catch(error => {
            console.error("POST error:", error);
            error_callback(error);
        }));
}


export const getDrfRequest = (url,
                              data_callback = data => {
                              },
                              error_callback = () => {
                              }) => {
    fetch(url, {
            method: 'GET',
            headers: {
                'X-CSRFToken': getCsrfToken(),
                'Content-Type': 'application/json'
            }
        }
    )
        .then(response => {
            if (!response.ok) {
                error_callback(response);
                return;
            }
            return response.json();
        })
        .then(data => {
            if (data) data_callback(data);
        })
        .catch(error => {
            console.error("GET error:", error);
            error_callback(error);
        });
    // )
    ;
}


/*
https://stackoverflow.com/questions/17781472/how-to-get-a-subset-of-a-javascript-objects-properties
 */
let pick = (obj, ...keys) => Object.fromEntries(
    keys
        .filter(key => key in obj)
        .map(key => [key, obj[key]])
);

let inclusivePick = (obj, ...keys) => Object.fromEntries(
    keys.map(key => [key, obj[key]])
);

let omit = (obj, ...keys) => Object.fromEntries(
    Object.entries(obj)
        .filter(([key]) => !keys.includes(key))
);


export const dict_no_empty_lists = (obj) => Object.fromEntries(Object.entries(obj).filter(([k, v]) => !(typeof v == "object" && !v.length)));


// there must be a better way.
export const dict_copy_whitelisted_keys = (d1, keys) => {
    return pick(d1, ...keys);
}
export const dict_delete_keys = (d, keys) => {
    keys.map((key) => delete d[key]);
}


export const object_is_empty = (obj) => (obj && Object.keys(obj).length === 0 && obj.constructor === Object);

export const getTodayDate = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}


export const getYesterdayDate = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}


export const parseRelativeDate = (value) => {
    if (value === 'today' || value === 'now') return getTodayDate();
    if (value === 'yesterday') return getYesterdayDate();
    return value;
}


export const format_date_short = (date) => {
    const date_object = new Date(date);
    return `${new Intl.DateTimeFormat("de-DE").format(date_object)}`
}
export const format_date_long = (date) => {
    const date_object = new Date(date);
    return `${new Intl.DateTimeFormat("de-DE", {dateStyle: 'full'}).format(date_object)}`
}
export const format_datetime_short = (date) => {
    const date_object = new Date(date);
    return `${new Intl.DateTimeFormat("de-DE", {dateStyle: 'short', timeStyle: 'short'}).format(date_object)}`
}
export const format_datetime_long = (date) => {
    const date_object = new Date(date);
    return `${new Intl.DateTimeFormat("de-DE", {dateStyle: 'full', timeStyle: 'full'}).format(date_object)}`
}

export const uniquify_list = (myList) => [...new Set(myList)]
export const extract_ean13_list = (some_string) => uniquify_list(Array.from(some_string.matchAll(/978\d{10}/g), m => m[0]))

